import { useTranslation } from "react-i18next"
import { TrendingUp } from "lucide-react"
import { useFeatureFlagEnabled } from "posthog-js/react"
import BaseSidebarButton from "./BaseSidebarButton"
import { TAB_TYPES } from "@/reducers/tabsSlice"
import { TrendingUpIconActive } from "@/components/icons/TrendingUpIcon"

const StatsSidebarButton = ({ className }: { className?: string }) => {
  const { t } = useTranslation()
  const isStatsEnabled = Boolean(useFeatureFlagEnabled("stats"))

  if (!isStatsEnabled) return null

  return (
    <BaseSidebarButton
      tabName={TAB_TYPES.STATS}
      icon={TrendingUp}
      activeIcon={TrendingUpIconActive}
      tooltipText={t("app.sidebar.stats")}
      className={className}
    />
  )
}

export default StatsSidebarButton
